export default __webpack_public_path__ + "static/media/warning--children--g2.802736a3.png";